(() => {
  'use strict';
  const configEl = document.getElementById('st-affiliate-config');
  if (!configEl) return;
  const config = JSON.parse(configEl.textContent);
  const filterKey = 'filter.p.m.custom.team_name';
  const scopes = new WeakMap();
  const cacheKey = 'st-team-directory:152443551788:v2:';
  const cacheTTL = 60000;
  const cached = new Map();
  const pending = new Map();
  const duckTeams = [
    {name: 'Anaheim Ducks', aliases: ['Anaheim Ducks', 'Anaheim Mighty Ducks', 'Mighty Ducks']},
    {name: 'Oregon Ducks', aliases: ['Oregon Ducks']},
    {name: 'Down East Wood Ducks', aliases: ['Down East Wood Ducks', 'Down East Ducks', 'Wood Ducks']},
    {name: 'Akron RubberDucks', aliases: ['Akron RubberDucks', 'Akron Rubber Ducks', 'RubberDucks', 'Rubber Ducks']}
  ].map(team => ({...team, label: team.name, heading: team.name, enabled: true, duck: true}));
  const duckChoices = {name: 'Ducks', label: 'Ducks', heading: 'Ducks', enabled: true, duck: true, choices: true};
  function intent(value) {
    if (typeof value !== 'string') return null;
    const cleaned = value.replace(/"diamondbacks"/gi, 'diamondbacks').trim();
    if (/[":()\\]|\b(?:AND|OR|NOT)\b/.test(cleaned)) return null;
    const matches = [];
    for (const team of [...config.teams, ...duckTeams]) {
      const aliases = [...team.aliases].sort((a, b) => b.length - a.length);
      const pattern = new RegExp('\\b(?:' + aliases.map(alias => alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')\\b', 'gi');
      if (pattern.test(cleaned)) matches.push({team, pattern});
    }
    if (matches.length === 0 && /\bducks\b/i.test(cleaned)) {
      return {team: duckChoices, minor: false, rest: cleaned.replace(/\bducks\b/gi, '').replace(/\s+/g, ' ').trim()};
    }
    if (matches.length !== 1 || !matches[0].team.enabled) return null;
    const {team, pattern} = matches[0];
    const minor = !team.duck && /\b(?:milb|minor[ -]leagues?|affiliates?)\b/i.test(cleaned);
    const rest = cleaned.replace(pattern, '').replace(/\b(?:milb|minor[ -]leagues?|affiliates?)\b/gi, '').replace(/\s+/g, ' ').trim();
    return {team, minor, rest};
  }
  async function directory(parsed) {
    if (parsed.team.duck) {
      const names = parsed.team.choices ? duckTeams.map(team => team.name) : [parsed.team.name];
      return {rootName: names[0], teams: names.slice(1)};
    }
    const key = parsed.team.handle;
    let entry = cached.get(key);
    if (!entry) {
      try { entry = JSON.parse(sessionStorage.getItem(cacheKey + key)); } catch (_) {}
    }
    if (entry && entry.time <= Date.now() && Date.now() - entry.time < cacheTTL && entry.data?.rootName === parsed.team.name && Array.isArray(entry.data.teams) && entry.data.teams.every(name => typeof name === 'string')) {
      cached.set(key, entry);
      return entry.data;
    }
    if (pending.has(key)) return pending.get(key);
    const request = (async () => {
      const entries = [];
      let url = new URL(config.search, location.origin);
      url.searchParams.set('q', parsed.team.name);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      let rootName;
      let pages = 0;
      do {
        url.searchParams.set('section_id', 'st-affiliate-directory');
        const response = await fetch(url, {cache: 'no-store', signal: AbortSignal.timeout(10000)});
        if (!response.ok) throw new Error('Directory unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(doc.querySelector('[data-st-affiliate-directory]').textContent);
        if (!data.rootResolved || !data.teamFilter || data.rootName !== parsed.team.name || data.pages > 10) throw new Error('Directory incomplete');
        rootName = data.rootName;
        entries.push(...data.teams);
        pages += 1;
        url = data.next ? new URL(data.next, location.origin) : null;
        if (url && url.origin !== location.origin) throw new Error('Invalid directory URL');
        if (url && preview) url.searchParams.set('preview_theme_id', preview);
      } while (url && pages < 10);
      if (url || !rootName || !entries.length) throw new Error('Directory incomplete');
      const data = {rootName, teams: [...new Set(entries.map(x => x.name))].sort()};
      const fresh = {time: Date.now(), data};
      cached.set(key, fresh);
      try { sessionStorage.setItem(cacheKey + key, JSON.stringify(fresh)); } catch (_) {}
      return data;
    })();
    pending.set(key, request);
    try { return await request; } finally { pending.delete(key); }
  }
  const stateKeys = ['st_intent', 'st_auto', 'st_explicit', 'st_type', 'st_type_explicit'];
  const typeKey = 'filter.p.product_type';
  function inferredTypes(rest, duck = false) {
    if (/\b(?:style|without|not|except)\b/i.test(rest)) return [];
    const jersey = /\bjerseys?\b/i.test(rest);
    const hat = /\b(?:hats?|caps?|fitteds?|snapbacks?|beanies?)\b/i.test(rest);
    const other = /\b(?:pins?|patch(?:es)?|shirts?|tees?|hoodies?|jackets?|flags?|wallets?|shorts?|pants?|bags?|ornaments?|decals?|stickers?|figurines?|frames?)\b/i.test(rest);
    if (other || (jersey && hat)) return [];
    if (jersey) return ['Jersey'];
    if (!duck || !hat) return [];
    if (/\bbeanies?\b/i.test(rest)) return ['Beanie'];
    if (/\bsnapbacks?\b/i.test(rest)) return ['Snapback Hat'];
    if (/\bfitteds?\b/i.test(rest)) return ['Fitted Hat'];
    return ['Fitted Hat', 'Snapback Hat', 'Beanie'];
  }
  function storedTypes(url) {
    const value = url.searchParams.get('st_type');
    if (!value) return [];
    if (!value.startsWith('[')) return [value];
    try {
      const values = JSON.parse(value);
      return Array.isArray(values) && values.every(item => typeof item === 'string') ? values : [];
    } catch (_) { return []; }
  }
  function applyType(url, rest, duck = false) {
    const desired = inferredTypes(rest, duck);
    const prior = storedTypes(url);
    const selected = url.searchParams.getAll(typeKey);
    const explicit = url.searchParams.get('st_type_explicit') === '1' || (prior.length ? !same(selected, prior) : selected.length > 0);
    if (!explicit && !same(selected, desired)) {
      url.searchParams.delete(typeKey);
      desired.forEach(type => url.searchParams.append(typeKey, type));
      if (!same(prior, desired)) url.searchParams.delete('page');
    }
    if (desired.length) url.searchParams.set('st_type', desired.length === 1 ? desired[0] : JSON.stringify(desired));
    else url.searchParams.delete('st_type');
    if (explicit) url.searchParams.set('st_type_explicit', '1');
    else url.searchParams.delete('st_type_explicit');
  }
  const same = (a, b) => JSON.stringify([...a].sort()) === JSON.stringify([...b].sort());
  function savedState(url) {
    const parsed = intent(url.searchParams.get('st_intent'));
    if (!parsed) return null;
    let auto;
    try { auto = JSON.parse(url.searchParams.get('st_auto')); } catch (_) { return null; }
    if (!Array.isArray(auto) || !auto.every(x => typeof x === 'string')) return null;
    return {...parsed, auto, explicit: url.searchParams.get('st_explicit') === '1'};
  }
  function friendly(parsed) {
    return parsed.team.label + (parsed.minor ? ' minor league' : '') + (parsed.rest ? ' ' + parsed.rest : '');
  }
  function route(source, parsed, data, resetPage = false) {
    const url = new URL(source);
    const previous = savedState(url);
    const names = parsed.minor ? data.teams : [data.rootName, ...data.teams];
    const selected = url.searchParams.getAll(filterKey);
    const explicit = previous ? previous.explicit || !same(selected, previous.auto) : selected.length > 0;
    const group = names.map(name => '"' + name.replace(/["\\]/g, '') + '"').join(' OR ');
    url.searchParams.set('q', parsed.rest || '(' + group + ')');
    url.searchParams.set('type', 'product');
    applyType(url, parsed.rest, parsed.team.duck);
    if (!explicit && !same(selected, names)) {
      url.searchParams.delete(filterKey);
      for (const name of names) url.searchParams.append(filterKey, name);
    }
    if (resetPage || previous && !same(previous.auto, names)) url.searchParams.delete('page');
    url.searchParams.set('st_intent', friendly(parsed));
    url.searchParams.set('st_auto', JSON.stringify(names));
    if (explicit) url.searchParams.set('st_explicit', '1');
    else url.searchParams.delete('st_explicit');
    return url;
  }
  function destination(names, extra, input, parsed) {
    const current = new URL(location.href);
    const url = new URL(config.search, location.origin);
    for (const [key, value] of current.searchParams) {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id' || key.startsWith('options[') || stateKeys.includes(key)) url.searchParams.append(key, value);
    }
    const form = input.form;
    if (form) for (const [key, value] of new FormData(form)) {
      if (key.startsWith('filter.') && value) url.searchParams.set(key, value);
    }
    if (parsed?.team.duck) {
      const prior = savedState(current);
      if (!prior || friendly(prior).toLowerCase() !== friendly(parsed).toLowerCase()) {
        url.searchParams.delete(filterKey);
        url.searchParams.delete(typeKey);
        stateKeys.forEach(key => url.searchParams.delete(key));
      }
    }
    if (parsed) return route(url, parsed, {rootName: names[0], teams: parsed.minor ? names : names.slice(1)}, true);
    // An explicit individual-team destination does not claim to be a parent-family search.
    applyType(url, extra);
    stateKeys.forEach(key => url.searchParams.delete(key));
    url.searchParams.set('q', extra || '"' + names[0] + '"');
    url.searchParams.set('type', 'product');
    url.searchParams.delete(filterKey);
    names.forEach(name => url.searchParams.append(filterKey, name));
    return url;
  }
  function facetParams(value, event) {
    const current = new URL(location.href);
    const state = savedState(current);
    if (!state) return value;
    const params = new URLSearchParams(value);
    stateKeys.forEach(key => { if (current.searchParams.has(key)) params.set(key, current.searchParams.get(key)); });
    // Shopify may omit selected low-count team values from its displayed facets.
    // Non-team controls must not silently discard those URL selections.
    if (event && ['input', 'change'].includes(event.type) && event.target?.name !== filterKey) {
      params.delete(filterKey);
      current.searchParams.getAll(filterKey).forEach(name => params.append(filterKey, name));
    }
    if (!same(params.getAll(filterKey), state.auto)) params.set('st_explicit', '1');
    const autoTypes = storedTypes(current);
    if (event && ['input', 'change'].includes(event.type) && event.target?.name !== typeKey) {
      params.delete(typeKey);
      current.searchParams.getAll(typeKey).forEach(name => params.append(typeKey, name));
    }
    if (autoTypes.length && !same(params.getAll(typeKey), autoTypes)) params.set('st_type_explicit', '1');
    return params.toString();
  }
  function displayIntent() {
    const current = new URL(location.href);
    const state = savedState(current);
    if (!state) return;
    const input = document.getElementById('header-search');
    if (input && document.activeElement !== input) input.value = friendly(state);
    document.title = friendly(state) + ' – Sports Treasures';
    document.querySelectorAll('#filter-results a[href]').forEach(link => {
      const url = new URL(link.href);
      if (url.pathname === config.search && url.searchParams.has('page')) {
        stateKeys.forEach(key => { if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key)); });
        link.href = url.href;
      }
    });
  }
  function release() { document.documentElement.classList.remove('st-affiliate-loading'); }
  async function refresh() {
    const before = location.href;
    const current = new URL(before);
    const parsed = savedState(current) || intent(current.searchParams.get('q'));
    if (current.pathname !== config.search || !parsed) { release(); return; }
    let navigating = false;
    try {
      const data = await directory(parsed);
      if (location.href !== before) return;
      const next = route(current, parsed, data);
      if (next.href !== current.href) { navigating = true; location.replace(next); return; }
      displayIntent();
    } catch (_) { /* Keep native results available if the directory cannot be read. */ }
    finally { if (!navigating) release(); }
  }
  window.stAffiliates = {intent, facetParams, displayIntent, refresh};
  function build(input, parsed, data) {
    const panel = document.createElement('aside');
    panel.className = 'st-affiliate-panel';
    panel.setAttribute('aria-label', parsed.team.heading);
    const title = document.createElement('strong');
    title.textContent = parsed.team.heading;
    panel.append(title);
    const list = document.createElement('ul');
    const add = (label, names, mode) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.textContent = label;
      link.href = destination(names, parsed.rest, input, mode).href;
      item.append(link); list.append(item);
    };
    if (parsed.team.duck) {
      const choices = parsed.team.choices ? duckTeams : [parsed.team];
      for (const team of choices) add(team.name, [team.name], {team, minor: false, rest: parsed.rest});
    } else {
      for (const name of data.teams) add(name, [name]);
    }
    panel.append(list);
    return panel;
  }
  async function renderPageAffiliates() {
    const mount = document.querySelector('[data-st-affiliate-page]');
    const input = document.getElementById('header-search');
    if (!mount || !input) return;
    const current = new URL(location.href);
    const parsed = savedState(current) || intent(current.searchParams.get('q'));
    if (!parsed || (parsed.team.duck && !parsed.team.choices)) { mount.replaceChildren(); return; }
    const before = location.href;
    try {
      const data = await directory(parsed);
      if (location.href === before) mount.replaceChildren(build(input, parsed, data));
    } catch (_) { mount.replaceChildren(); }
  }
  function attach(input) {
    if (scopes.has(input)) return;
    const state = {panel: null, serial: 0, timer: null, observer: null};
    scopes.set(input, state);
    const host = input.closest('predictive-search');
    const results = input.id !== 'main-search' && host && host.querySelector('.js-search-results');
    const mount = () => {
      if (!state.panel) return;
      if (results) {
        const target = results.querySelector('.predictive-search__scroller');
        if (target && !target.contains(state.panel)) target.prepend(state.panel);
      } else if (!state.panel.isConnected) input.form?.after(state.panel);
    };
    if (results) {
      state.observer = new MutationObserver(mount);
      state.observer.observe(results, {childList: true, subtree: true});
    }
    const update = async () => {
      const serial = ++state.serial;
      state.panel?.remove();
      state.panel = null;
      const normalized = input.value.trim().toLowerCase().replace(/\s+/g, ' ');
      if (results && config.jerseys?.queries.includes(normalized)) {
        const panel = document.createElement('div');
        panel.className = 'st-affiliate-panel';
        const link = document.createElement('a');
        const url = new URL(config.jerseys.url, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        link.href = url.href;
        link.textContent = config.jerseys.label;
        panel.append(link);
        state.panel = panel;
        mount();
        return;
      }
      const parsed = intent(input.value);
      if (!parsed) return;
      try {
        const data = await directory(parsed);
        if (serial !== state.serial || !input.isConnected) return;
        state.panel = build(input, parsed, data);
        mount();
      } catch (_) {}
    };
    input.addEventListener('input', () => {
      state.serial += 1;
      state.panel?.remove(); state.panel = null;
      clearTimeout(state.timer);
      state.timer = setTimeout(update, 250);
    });
    input.addEventListener('focus', update);
    document.addEventListener('on:facet-filters:updated', update);
    let submitting = false;
    input.form?.addEventListener('submit', async event => {
      if (submitting || event.defaultPrevented) return;
      const parsed = intent(input.value);
      if (!parsed) return;
      event.preventDefault();
      const submitted = input.value;
      try {
        const data = await directory(parsed);
        if (input.value === submitted) location.assign(destination(parsed.minor ? data.teams : [data.rootName, ...data.teams], parsed.rest, input, parsed));
      } catch (_) {
        submitting = true;
        input.form.requestSubmit();
        submitting = false;
      }
    });
    host?.querySelector('.js-search-product-types')?.addEventListener('change', update);
    if (input.value) update();
  }
  function scan() {
    document.querySelectorAll('form[action] input[name="q"]').forEach(input => {
      if (new URL(input.form.action, location.origin).pathname === config.search) attach(input);
    });
  }
  displayIntent();
  scan();
  refresh();
  renderPageAffiliates();
  document.addEventListener('on:facet-filters:updated', renderPageAffiliates);
  document.addEventListener('on:facet-filters:updated', displayIntent);
  window.addEventListener('pageshow', event => { if (event.persisted) { cached.clear(); refresh(); } });
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
})();

